import React from 'react'
import {useEffect, useState, useContext} from 'react'
import {Link, useNavigate, useParams} from 'react-router-dom'
import useGet from '../../hooks/useGet'
import PortalDealCard from './PortalDealCard'
import Button from '../Button'
import PortalDealListFilters from './PortalDealListFilters'

import portalContext from '../../store/PortalContext'


const PortalRequestsListView = ({stageOptions}) => {
    const [selectedStage, setSelectedStage] = useState(null)

    const [stageDealUrl, setStageDealUrl] = useState(null)

    const {loading: dealDataLoading, error, returnData: dealData, getData} = useGet(stageDealUrl)
    const navigate = useNavigate()

    const [filterByMember, setFilterByMember] = useState(null)

    let [filteredResults, setFilteredResults] = useState([])
    const [hasFilter, setHasFilter] = useState(false)

    const portalCtx = useContext(portalContext)
    

    useEffect(() => {
        if(!selectedStage && stageOptions != null && stageOptions.length) {
            setSelectedStage(stageOptions[0])
        }
    }, [stageOptions])

    useEffect(() => {
        if(selectedStage){
            setStageDealUrl(`/api/portal/deals-by-stage?stageLabel=${selectedStage}&f=all`)
        }
    }, [selectedStage])

    const changeStage = (newStage) => {
        setSelectedStage(newStage)
    }

    useEffect(() => {
        if(dealData) {
            filteredResults = dealData
        }
    }, [dealData, dealDataLoading])

    const gotoDeal = (deal) => {
        navigate(`/portal/deal-details/sales/${deal.id}`, {
            state: {
                deal: deal
            }
        })
    }

    useEffect(() => {
        setFilteredResults(dealData)

        if(dealData && filterByMember) {
            const tmpF = dealData.filter(
                (d) => {
                    console.log(d)
                    switch(filterByMember.zohoModule) {
                        case 'Leads': {
                            return filterByMember.zohoId === d['lead_Name.Id']
                        }
                        case 'Contacts': {
                            return filterByMember.zohoId === d['contact_Name.Id']
                        }
                    }

                    return false;
                }
            )

            setFilteredResults(tmpF)    

            console.log(filteredResults)
        }
    }, [dealData, filterByMember])

    const updateSelectedClientLead = (newLead) => {
        if(newLead) {
            setHasFilter(true)
        } else {
            setHasFilter(false)
        }
        setFilterByMember(newLead)
    }
    
    const updateSelectedViewFilter = (newFilter) => {
        if(newFilter == 'Mine') {
            //
            setStageDealUrl(`/api/portal/deals-by-stage-by-owner?stageLabel=${selectedStage}&ownerId=${portalCtx.id}`)
        } else {
            setStageDealUrl(`/api/portal/deals-by-stage?stageLabel=${selectedStage}&f=${newFilter}`)
        }

    }

    return (
        <>
            {(stageOptions != null) && 
                <div className="portal__stagefilter_wrapper">
                {
                    stageOptions.map((opt, index) => {
                        return (
                            <Button key={index}
                                onClick={() => changeStage(opt)} disabled={opt === selectedStage}>{opt}</Button>
                        )
                    })
                }
                </div>
            }

            <PortalDealListFilters 
                onDidSelectMember={updateSelectedClientLead}
                onDidChangeFilter={updateSelectedViewFilter}
            />
            
            {(selectedStage && !dealDataLoading && (filteredResults || dealData) &&
                    <div className='portal__dealcards'>
                        {(hasFilter ? filteredResults : dealData).map((deal, index) => {
                            return (
                                <div onClick={()=>gotoDeal(deal)} key={deal.id}>
                                    <PortalDealCard
                                        deal={deal}
                                    />
                                </div>
                            )
                        })}    

                        
                    </div>
                )}
                
                {(dealDataLoading &&
                    <>
                        <h1 className="portal__title portal__title__loading">Loading...{selectedStage}.</h1>
                    </>
                )}
                {(!dealDataLoading && (!dealData || (hasFilter && filteredResults.length === 0)) &&
                    <>
                        <h1 className="portal__title portal__title__loading">No results for {selectedStage}</h1>
                    </>
                )}
            
        </>
    )
}

export default PortalRequestsListView